import { useRef, useEffect, useState } from 'react';

interface ClientCard {
  sector: string;
  client: string;
  description: string;
  logo?: string;
  icon?: string;
}

export default function TrustedBy() {
  const scrollRef = useRef<HTMLDivElement>(null);
  const [isPaused, setIsPaused] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  const clients: ClientCard[] = [
    {
      sector: "Military, Federal & Government",
      client: "Balfour Beatty Communities",
      description: "MHPI / P3 military housing environmental lead for 10,000+ family units",
      logo: "https://public.readdy.ai/ai/img_res/68d15f5b40b772dd61522505de1a6d00.jpg"
    },
    {
      sector: "Military, Federal & Government",
      client: "United States Postal Service",
      description: "Nationwide hazardous materials and indoor air quality support",
      logo: "https://readdy.ai/api/search-image?query=United%20States%20Postal%20Service%20USPS%20official%20logo%20eagle%20symbol%20on%20white%20background&width=200&height=200&seq=usps1&orientation=squarish"
    },
    {
      sector: "Military, Federal & Government",
      client: "U.S. Army Corps of Engineers",
      description: "Environmental consulting for major federal facilities and campuses",
      logo: "https://readdy.ai/api/search-image?query=US%20Army%20Corps%20of%20Engineers%20official%20emblem%20castle%20logo%20on%20white%20background&width=200&height=200&seq=usace1&orientation=squarish"
    },
    {
      sector: "Military, Federal & Government",
      client: "U.S. Securities and Exchange Commission",
      description: "Headquarters and office portfolio hazardous materials consulting",
      logo: "https://readdy.ai/api/search-image?query=US%20Securities%20and%20Exchange%20Commission%20SEC%20official%20seal%20emblem%20on%20white%20background&width=200&height=200&seq=sec1&orientation=squarish"
    },
    {
      sector: "Military, Federal & Government",
      client: "Transportation Security Administration",
      description: "Critical security facility environmental assessments",
      logo: "https://readdy.ai/api/search-image?query=Transportation%20Security%20Administration%20TSA%20official%20logo%20eagle%20shield%20on%20white%20background&width=200&height=200&seq=tsa1&orientation=squarish"
    },
    {
      sector: "Military, Federal & Government",
      client: "American Stock Exchange",
      description: "Environmental due diligence and hazardous materials surveys",
      icon: "ri-stock-line"
    },
    {
      sector: "Military, Federal & Government",
      client: "United States Military Academy at West Point",
      description: "Historic housing MHPI environmental program and lead/asbestos support",
      logo: "https://readdy.ai/api/search-image?query=United%20States%20Military%20Academy%20West%20Point%20official%20coat%20of%20arms%20emblem%20on%20white%20background&width=200&height=200&seq=westpoint1&orientation=squarish"
    },
    {
      sector: "Military, Federal & Government",
      client: "Picatinny Arsenal",
      description: "Basewide lead, asbestos, and hazardous materials services",
      icon: "ri-building-4-line"
    },
    {
      sector: "Military, Federal & Government",
      client: "National Park Service",
      description: "Historic building hazardous materials and preservation-focused consulting",
      logo: "https://readdy.ai/api/search-image?query=National%20Park%20Service%20NPS%20official%20arrowhead%20logo%20emblem%20on%20white%20background&width=200&height=200&seq=nps1&orientation=squarish"
    },
    {
      sector: "Industrial & Defense",
      client: "General Motors",
      description: "Multi-plant asbestos and hazardous materials management programs",
      logo: "https://readdy.ai/api/search-image?query=General%20Motors%20GM%20company%20logo%20official%20corporate%20branding%20on%20white%20background&width=200&height=200&seq=gm1&orientation=squarish"
    },
    {
      sector: "Industrial & Defense",
      client: "Lockheed Martin",
      description: "Defense facility environmental surveys and compliance support",
      logo: "https://readdy.ai/api/search-image?query=Lockheed%20Martin%20company%20logo%20official%20corporate%20branding%20on%20white%20background&width=200&height=200&seq=lockheed1&orientation=squarish"
    },
    {
      sector: "Construction & Major Capital Projects",
      client: "Turner Construction",
      description: "Environmental support for large renovations and major capital projects",
      logo: "https://readdy.ai/api/search-image?query=Turner%20Construction%20company%20logo%20official%20corporate%20branding%20on%20white%20background&width=200&height=200&seq=turner1&orientation=squarish"
    },
    {
      sector: "Construction & Major Capital Projects",
      client: "Clark Construction",
      description: "Environmental consulting for large-scale construction and redevelopment projects",
      icon: "ri-building-2-line"
    },
    {
      sector: "Construction & Major Capital Projects",
      client: "The Michaels Organization",
      description: "Environmental support for affordable housing development and P3 projects",
      logo: "https://readdy.ai/api/search-image?query=The%20Michaels%20Organization%20company%20logo%20official%20corporate%20branding%20on%20white%20background&width=200&height=200&seq=michaels1&orientation=squarish"
    },
    {
      sector: "Transportation & Infrastructure",
      client: "Amtrak",
      description: "Rail facilities and station hazardous materials and IAQ programs",
      logo: "https://readdy.ai/api/search-image?query=Amtrak%20official%20logo%20train%20company%20branding%20on%20white%20background&width=200&height=200&seq=amtrak1&orientation=squarish"
    },
    {
      sector: "Transportation & Infrastructure",
      client: "Triborough Bridge & Tunnel Authority",
      description: "Bridge and tunnel portfolio environmental consulting",
      icon: "ri-road-map-line"
    },
    {
      sector: "Transportation & Infrastructure",
      client: "Metropolitan Transportation Authority (MTA)",
      description: "Transit system hazardous building materials management",
      logo: "https://readdy.ai/api/search-image?query=MTA%20Metropolitan%20Transportation%20Authority%20New%20York%20official%20logo%20on%20white%20background&width=200&height=200&seq=mta1&orientation=squarish"
    },
    {
      sector: "Transportation & Infrastructure",
      client: "New Jersey Transit Authority",
      description: "Statewide transit capital project environmental services",
      logo: "https://readdy.ai/api/search-image?query=New%20Jersey%20Transit%20NJ%20Transit%20official%20logo%20on%20white%20background&width=200&height=200&seq=njtransit1&orientation=squarish"
    },
    {
      sector: "Telecom & Critical Infrastructure",
      client: "Verizon",
      description: "Switch and network facility hazardous materials assessments",
      logo: "https://readdy.ai/api/search-image?query=Verizon%20company%20logo%20official%20corporate%20branding%20red%20checkmark%20on%20white%20background&width=200&height=200&seq=verizon1&orientation=squarish"
    },
    {
      sector: "Telecom & Critical Infrastructure",
      client: "AT&T",
      description: "Telecom infrastructure environmental surveys and compliance",
      logo: "https://readdy.ai/api/search-image?query=AT%20and%20T%20company%20logo%20official%20corporate%20branding%20globe%20symbol%20on%20white%20background&width=200&height=200&seq=att1&orientation=squarish"
    },
    {
      sector: "Pharmaceutical & Life Sciences",
      client: "Aventis",
      description: "Pharmaceutical facility hazardous materials and environmental compliance programs",
      icon: "ri-flask-line"
    },
    {
      sector: "Pharmaceutical & Life Sciences",
      client: "Pfizer",
      description: "Laboratory and R&D facility hazardous materials programs",
      logo: "https://readdy.ai/api/search-image?query=Pfizer%20pharmaceutical%20company%20logo%20official%20corporate%20branding%20on%20white%20background&width=200&height=200&seq=pfizer1&orientation=squarish"
    },
    {
      sector: "Pharmaceutical & Life Sciences",
      client: "Hoffmann-La Roche",
      description: "Life sciences facility environmental consulting and compliance support",
      logo: "https://readdy.ai/api/search-image?query=Hoffmann%20La%20Roche%20pharmaceutical%20company%20logo%20official%20corporate%20branding%20on%20white%20background&width=200&height=200&seq=roche1&orientation=squarish"
    },
    {
      sector: "Pharmaceutical & Life Sciences",
      client: "Eli Lilly & Company",
      description: "Pharmaceutical research and manufacturing facility environmental programs",
      logo: "https://readdy.ai/api/search-image?query=Eli%20Lilly%20and%20Company%20pharmaceutical%20logo%20official%20corporate%20branding%20on%20white%20background&width=200&height=200&seq=lilly1&orientation=squarish"
    },
    {
      sector: "Healthcare & Hospitals",
      client: "Hospitals & Health Systems",
      description: "Asbestos, lead, IAQ, and hazardous materials support in active healthcare environments",
      icon: "ri-hospital-line"
    },
    {
      sector: "Retail, Commercial & Developers",
      client: "Dick's Sporting Goods",
      description: "National retail portfolio environmental programs and store assessments",
      logo: "https://readdy.ai/api/search-image?query=Dicks%20Sporting%20Goods%20company%20logo%20official%20retail%20branding%20on%20white%20background&width=200&height=200&seq=dicks1&orientation=squarish"
    },
    {
      sector: "Retail, Commercial & Developers",
      client: "Vornado Realty Trust",
      description: "Large commercial real estate portfolio environmental consulting and compliance",
      logo: "https://readdy.ai/api/search-image?query=Vornado%20Realty%20Trust%20company%20logo%20official%20corporate%20branding%20on%20white%20background&width=200&height=200&seq=vornado1&orientation=squarish"
    },
    {
      sector: "Hospitality & Hotels",
      client: "Marriott",
      description: "Renovation and capital improvement hazardous materials consulting",
      logo: "https://readdy.ai/api/search-image?query=Marriott%20hotel%20company%20logo%20official%20corporate%20branding%20on%20white%20background&width=200&height=200&seq=marriott1&orientation=squarish"
    },
    {
      sector: "Education & Public Schools",
      client: "Jersey City Public Schools",
      description: "District-wide lead and asbestos programs for K–12 facilities",
      icon: "ri-school-line"
    },
    {
      sector: "Education & Public Schools",
      client: "New Jersey Schools Development Authority",
      description: "Statewide school construction environmental compliance programs",
      icon: "ri-book-open-line"
    }
  ];

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  useEffect(() => {
    const scrollContainer = scrollRef.current;
    if (!scrollContainer || isPaused || isMobile) return;

    let animationId: number;
    let scrollPosition = scrollContainer.scrollLeft;

    const scroll = () => {
      if (!isPaused) {
        scrollPosition += 0.5;
        if (scrollContainer) {
          scrollContainer.scrollLeft = scrollPosition;
          
          if (scrollPosition >= scrollContainer.scrollWidth / 2) {
            scrollPosition = 0;
          }
        }
      }
      animationId = requestAnimationFrame(scroll);
    };

    animationId = requestAnimationFrame(scroll);

    return () => {
      if (animationId) {
        cancelAnimationFrame(animationId);
      }
    };
  }, [isPaused, isMobile]);

  const duplicatedClients = [...clients, ...clients];

  return (
    <section className="py-12 sm:py-16 bg-gradient-to-br from-gray-50 to-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-8 sm:mb-10">
        <div className="text-center">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-black mb-3 sm:mb-4 px-4">
            Trusted to protect properties and the people in them
          </h2>
          <p className="text-sm sm:text-base text-gray-600 max-w-3xl mx-auto px-4">
            Representative clients and programs where we've delivered portfolio-level environmental consulting.
          </p>
        </div>
      </div>

      <div 
        ref={scrollRef}
        className="flex gap-4 sm:gap-6 overflow-x-auto px-4"
        onMouseEnter={() => !isMobile && setIsPaused(true)}
        onMouseLeave={() => !isMobile && setIsPaused(false)}
        style={{ 
          scrollbarWidth: 'thin', 
          msOverflowStyle: 'auto',
          WebkitOverflowScrolling: 'touch',
          scrollSnapType: isMobile ? 'x mandatory' : 'none',
          scrollBehavior: 'smooth'
        }}
      >
        {duplicatedClients.map((client, index) => (
          <div
            key={index}
            className="flex-shrink-0 w-72 sm:w-80 bg-white rounded-xl border border-gray-200 p-5 sm:p-6 hover:shadow-2xl transition-all duration-300 hover:border-[#f59e0b] group"
            style={{ scrollSnapAlign: isMobile ? 'center' : 'none' }}
          >
            <div className="flex items-start gap-3 sm:gap-4 mb-3 sm:mb-4">
              <div className="w-12 h-12 sm:w-14 sm:h-14 bg-white rounded-lg flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform duration-300 border border-gray-100">
                {client.logo ? (
                  <img 
                    src={client.logo} 
                    alt={`${client.client} logo`}
                    className="w-10 h-10 sm:w-12 sm:h-12 object-contain"
                    loading="lazy"
                    onError={(e) => {
                      const target = e.target as HTMLImageElement;
                      target.style.display = 'none';
                      const parent = target.parentElement;
                      if (parent) {
                        parent.innerHTML = '<div class="w-full h-full bg-gradient-to-br from-[#f59e0b] to-[#d97706] rounded-lg flex items-center justify-center"><i class="ri-building-4-line text-xl sm:text-2xl text-white"></i></div>';
                      }
                    }}
                  />
                ) : (
                  <div className="w-full h-full bg-gradient-to-br from-[#f59e0b] to-[#d97706] rounded-lg flex items-center justify-center">
                    <i className={`${client.icon} text-xl sm:text-2xl text-white`}></i>
                  </div>
                )}
              </div>
              <div className="flex-1 min-w-0">
                <span className="text-xs font-semibold text-[#f59e0b] uppercase tracking-wider block mb-1 sm:mb-2">
                  {client.sector}
                </span>
                <h3 className="text-base sm:text-lg font-bold text-black leading-tight">
                  {client.client}
                </h3>
              </div>
            </div>
            <p className="text-xs sm:text-sm text-gray-600 leading-relaxed">
              {client.description}
            </p>
          </div>
        ))}
      </div>

      <style>{`
        div[style*="scrollbarWidth"] {
          -webkit-overflow-scrolling: touch;
        }
        div[style*="scrollbarWidth"]::-webkit-scrollbar {
          height: 8px;
        }
        div[style*="scrollbarWidth"]::-webkit-scrollbar-track {
          background: #f1f1f1;
          border-radius: 10px;
        }
        div[style*="scrollbarWidth"]::-webkit-scrollbar-thumb {
          background: #f59e0b;
          border-radius: 10px;
        }
        div[style*="scrollbarWidth"]::-webkit-scrollbar-thumb:hover {
          background: #d97706;
        }
      `}</style>
    </section>
  );
}
